export default {
  billingInfo: (tenantID: string) => ["mspBillingInfo", tenantID] as const,
  billingStatements: (tenantID: string) =>
    ["mspBillingStatements", tenantID] as const,
};
